export enum ModalId {
  Activation,
  CoApplicant,
  CreateSavedSearch,
  Geolocation,
  ManageSavedSearches,
  MoreDetails,
  SoftPull,
  WIPNotifications
}

export const ModalPriorities = {
  [ModalId.SoftPull]: 1
};
